module.exports = __webpack_public_path__ + "img/logo_asus.eb966940.png";